import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../assets/tweezers.svg"

export default function More() {
  const [confetti, setConfetti] = useState([]);
  const navigate = useNavigate();

  // Generate confetti particles
  useEffect(() => {
    const particles = [];
    const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#f0932b', '#eb4d4b', '#6c5ce7', '#a29bfe'];
    const shapes = ['square', 'circle', 'triangle'];
    
    for (let i = 0; i < 30; i++) {
      // Position confetti around the center where the ball emoji is - shifted up
      const centerX = 50; // Center of screen
      const centerY = 25; // Moved up from 40 to 25
      const radius = 15; // Spread radius around the ball
      
      particles.push({
        id: i,
        left: centerX + (Math.random() - 0.5) * radius * 2,
        top: centerY + (Math.random() - 0.5) * radius * 2,
        animationDelay: Math.random() * 2,
        animationDuration: 2 + Math.random() * 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        shape: shapes[Math.floor(Math.random() * shapes.length)],
        size: 4 + Math.random() * 6,
        rotation: Math.random() * 360,
      });
    }
    setConfetti(particles);
  }, []);

  const handleCreateAccount = () => {
    navigate('/auth/signup');
  };

   const handleManageAccount = () => {
    navigate('/account/profile');
  };

  return (
    <div className="min-h-screen bg-white flex flex-col relative overflow-hidden">
      {/* Confetti */}
      {confetti.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-float"
          style={{
            left: `${particle.left}%`,
            top: `${particle.top}%`,
            animationDelay: `${particle.animationDelay}s`,
            animationDuration: `${particle.animationDuration}s`,
          }}
        >
          <div
            className={`confetti-${particle.shape}`}
            style={{
              backgroundColor: particle.shape === 'triangle' ? 'transparent' : particle.color,
              borderBottomColor: particle.shape === 'triangle' ? particle.color : 'transparent',
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              transform: `rotate(${particle.rotation}deg)`,
            }}
          />
        </div>
      ))}

      {/* Header */}
      <header className="flex items-center justify-between px-4 py-4 md:px-8 md:py-6 relative z-10">
        <div className="flex items-center">
        
          {/* Logo from assets */}
          <div className="flex items-center m-4">
            <img 
              src={logo}
              alt="Tweezers Logo" 
              className="h-8 md:h-10 w-auto"
              onError={(e) => {
                // Fallback if logo doesn't exist
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="text-green-600 text-2xl md:text-3xl font-bold hidden">
              TWEEZERS
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-8 md:py-16 relative z-10">
        {/* Football Icon */}
        <div className="mb-8 md:mb-12">
          <div className="w-24 h-24 md:w-32 md:h-32 mx-auto flex items-center justify-center">
            <span className="text-6xl md:text-8xl">⚽</span>
          </div>
        </div>

        {/* Main Text */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-8 md:mb-12 max-w-2xl leading-tight">
          Join The Winning Squad?
        </h1>

        {/* Action Buttons */}
        <div className="w-full max-w-sm space-y-4">
          <button 
            onClick={handleCreateAccount}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 text-base md:text-lg"
          >
            Create an Account
          </button>

           <button 
            onClick={handleManageAccount}
            className="w-full bg-gray-500  text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 text-base md:text-lg"
          >
            Manage Account
          </button>
        </div>

        {/* Additional CTA Text */}
        <p className="text-center text-gray-600 text-sm md:text-base mt-6 max-w-md">
          Join for free and get expert-backed football betting insights. Stay ahead of the game!
        </p>
      </main>

      {/* Footer */}
      <footer className="px-4 py-6 md:px-8 md:py-8 text-center relative z-10">
       
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs md:text-sm text-gray-500">
          <a href="/policies" className="hover:text-gray-700 transition-colors">Terms of Use & Privacy</a>
        </div>
      </footer>

      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            25% {
              transform: translateY(-10px) rotate(90deg);
            }
            50% {
              transform: translateY(-5px) rotate(180deg);
            }
            75% {
              transform: translateY(-15px) rotate(270deg);
            }
          }
          
          .animate-float {
            animation: float ease-in-out infinite;
          }
          
          .confetti-square {
            transform-origin: center;
          }
          
          .confetti-circle {
            border-radius: 50%;
            transform-origin: center;
          }
          
          .confetti-triangle {
            width: 0 !important;
            height: 0 !important;
            background: transparent !important;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 8px solid;
            transform-origin: center;
          }
        `
      }} />
    </div>
  );
}